import { useState } from 'react';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listArticles } from '@mkcore/portal/schema';
import { Card, EmptyState, Field, Input, Skeleton } from '@mkcore/ui';
import { call } from '@/lib/api';

/** The knowledge base of the client (CO-0497): its own articles and those for every client. */
export const Route = createFileRoute('/portal/_client/articles/')({
  component: Articles,
});

function Articles() {
  const { t } = useTranslation();
  const [q, setQ] = useState('');
  const list = useQuery({ queryKey: ['portal', 'articles', q.trim()], queryFn: () => call(listArticles, { q: q.trim() || undefined }) });
  return (
    <>
      <h1 className="text-2xl font-bold">{t('portal.modules.articles')}</h1>
      <Field label={t('portal.articles.search')}>{(p) => <Input {...p} type="search" value={q} onChange={(e) => setQ(e.target.value)} />}</Field>
      {!list.data ? (
        <Skeleton className="h-32" />
      ) : !list.data.items.length ? (
        <EmptyState title={t('portal.articles.empty')} />
      ) : (
        <ul className="grid gap-2">
          {list.data.items.map((a) => (
            <li key={a.id}>
              <Card className="grid gap-1 p-4">
                <Link to="/portal/articles/$id" params={{ id: a.id }} className="font-bold hover:underline">
                  {a.title}
                </Link>
                {a.category && <p className="text-xs text-fg-3">{a.category}</p>}
                <p className="text-sm text-fg-2">{a.excerpt}</p>
              </Card>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
